module.exports = __webpack_public_path__ + "img/banner_11.9f0a23d6.jpg";